"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectAction = void 0;
const react_i18next_1 = require("react-i18next");
const luxon_1 = require("luxon");
const components_1 = require("../../../../../components");
const hooks_1 = require("../../../../../hooks");
const consts_1 = require("../../../../../consts");
const utils_1 = require("../../../../../utils");
const context_1 = require("../../../../../components/PunchWorkflow/context");
const react_1 = require("react");
const useSelectAction = ({ isWeb = false }) => {
    var _a, _b, _c;
    const { t } = (0, react_i18next_1.useTranslation)();
    const { associateInfo, featureGates, selectedDateTime, selectedPunchList, payPeriodBreakdownInfo, action: selectedAction, setPayPeriodBreakdownInfo, setCurrentStepTitle, setShowErrorFallback, setIsCurrentStepValid, setTotalSteps } = (0, context_1.usePunchWorkflowContext)();
    (0, react_1.useEffect)(() => {
        setCurrentStepTitle(t('time_and_attendance_PunchWorkflow_SelectActionStep_Title'));
        setTotalSteps(5);
        setShowErrorFallback(false);
        setIsCurrentStepValid(!!selectedAction);
    }, []);
    const { isLoading: isPayPeriodsLoading, data: { pay_period_breakdown_info } = {}, error } = (0, hooks_1.usePayPeriod)({
        employeeId: associateInfo.employeeId,
        shouldFetch: !payPeriodBreakdownInfo,
        usageLocation: consts_1.featureNames.PUNCH_WORKFLOW_FEATURE
    });
    (0, react_1.useEffect)(() => {
        if (!isPayPeriodsLoading && !payPeriodBreakdownInfo) {
            setPayPeriodBreakdownInfo(pay_period_breakdown_info);
        }
    }, [
        isPayPeriodsLoading,
        payPeriodBreakdownInfo,
        pay_period_breakdown_info,
        setPayPeriodBreakdownInfo
    ]);
    const prevPayPeriodStart = ((_a = pay_period_breakdown_info === null || pay_period_breakdown_info === void 0 ? void 0 : pay_period_breakdown_info.previous) === null || _a === void 0 ? void 0 : _a.start_time)
        ? luxon_1.DateTime.fromISO(pay_period_breakdown_info.previous.start_time)
        : luxon_1.DateTime.now().minus({ days: 14 });
    const currPayPeriodStart = ((_b = pay_period_breakdown_info === null || pay_period_breakdown_info === void 0 ? void 0 : pay_period_breakdown_info.current) === null || _b === void 0 ? void 0 : _b.start_time)
        ? luxon_1.DateTime.fromISO(pay_period_breakdown_info.current.start_time)
        : luxon_1.DateTime.now().minus({ days: 7 });
    const currPayPeriodEnd = ((_c = pay_period_breakdown_info === null || pay_period_breakdown_info === void 0 ? void 0 : pay_period_breakdown_info.current) === null || _c === void 0 ? void 0 : _c.end_time)
        ? luxon_1.DateTime.fromISO(pay_period_breakdown_info.current.end_time)
        : luxon_1.DateTime.now();
    const isInCurrPayPeriod = (0, utils_1.isWithinDateTimeRange)(selectedDateTime, currPayPeriodStart, currPayPeriodEnd);
    const isInCurrAndPrevPayPeriod = (0, utils_1.isWithinDateTimeRange)(selectedDateTime, prevPayPeriodStart, currPayPeriodEnd);
    const isInFuture = selectedDateTime > luxon_1.DateTime.now();
    const isAddAvailable = featureGates.isSubmitMissedPunchEnabled;
    const isDeleteAvailable = featureGates.isDeleteDupePunchEnabled ||
        (isWeb && featureGates.isDeleteMpcaMpcsForWebEnabled) ||
        (!isWeb && featureGates.isDeleteMpcaMpcsForNativeEnabled);
    const isLoading = isPayPeriodsLoading;
    const actionOptions = [
        {
            titleText: t('time_and_attendance_PunchWorkflow_SelectActionStep_Options_AddPunch'),
            value: components_1.PUNCH_WORKFLOW_ACTIONS.ADD,
            ariaLabel: t('time_and_attendance_PunchWorkflow_SelectActionStep_Options_AddPunch_A11y'),
            disabled: !isInCurrAndPrevPayPeriod || isInFuture,
            featureAvailable: isAddAvailable
        },
        {
            titleText: t('time_and_attendance_PunchWorkflow_SelectActionStep_Options_EditPunch'),
            value: components_1.PUNCH_WORKFLOW_ACTIONS.EDIT,
            ariaLabel: t('time_and_attendance_PunchWorkflow_SelectActionStep_Options_EditPunch_A11y'),
            disabled: isInFuture || selectedPunchList.length === 0,
            featureAvailable: (isWeb && featureGates.isPunchEditForWebEnabled) ||
                (!isWeb && featureGates.isPunchEditForNativeEnabled)
        },
        {
            titleText: t('time_and_attendance_PunchWorkflow_SelectActionStep_Options_DeletePunch'),
            value: components_1.PUNCH_WORKFLOW_ACTIONS.DELETE,
            ariaLabel: t('time_and_attendance_PunchWorkflow_SelectActionStep_Options_DeletePunch_A11y'),
            disabled: !isInCurrPayPeriod || isInFuture || selectedPunchList.length === 0,
            featureAvailable: isDeleteAvailable
        }
    ];
    let warningMessage = '';
    if (!isInCurrAndPrevPayPeriod) {
        if (isAddAvailable || isDeleteAvailable) {
            warningMessage = t(`time_and_attendance_PunchWorkflow_SelectActionStep_Banner_${isAddAvailable ? components_1.PUNCH_WORKFLOW_ACTIONS.ADD : ''}${isDeleteAvailable ? components_1.PUNCH_WORKFLOW_ACTIONS.DELETE : ''}Ineligible`);
        }
    }
    else if (!isInCurrPayPeriod) {
        if (isDeleteAvailable) {
            warningMessage = t('time_and_attendance_PunchWorkflow_SelectActionStep_Banner_DeleteIneligible');
        }
    }
    return {
        isLoading,
        actionOptions,
        warningMessage,
        error
    };
};
exports.useSelectAction = useSelectAction;
